import api from "../../util/api";

export const createTrack = async ({name}) => {
    const config = {
        method: "post",
        url: `v2/api/settings/tracks`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        data: {name},
    };

    return api(config)
        .then(({data}) => {
            return data;
        })
        .catch(({message}) => {
            console.error(message);
            return {message};
        });
};

export const editTrack = async (value, key, trackId) => {
    const config = {
        method: "put",
        url: `v2/api/settings/tracks/${trackId}`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        data: {[key]: value},
    };

    return api(config)
        .then(({data}) => {
            return data;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};

export const deleteTrack = async trackId => {
    const config = {
        method: "delete",
        url: `v2/api/settings/tracks/${trackId}`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    };

    return api(config)
        .then(({data}) => {
            return data;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};

export const updateFolderImgTrack = async ({id, file, onSuccess = () => {}, onError = () => {}}) => {
    let data = new FormData();
    data.append("picture", file);

    const config = {
        method: "post",
        url: `v2/api/settings/tracks/${id}/upload/picture`,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data,
    };

    return api(config)
        .then(({data}) => {
            if (data.result && data.result === "success") {
                onSuccess();
            } else {
                onError();
            }
            return data;
        })
        .catch(err => {
            console.error(err);
            onError();
            return false;
        });
};

export const updateHeaderImgTrack = async ({id, file, onSuccess = () => {}, onError = () => {}}) => {
    let data = new FormData();
    data.append("header", file);

    const config = {
        method: "post",
        url: `v2/api/settings/tracks/${id}/upload/header`,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data,
    };

    return api(config)
        .then(({data}) => {
            if (data.result && data.result === "success") {
                onSuccess();
            } else {
                onError();
            }
            return data;
        })
        .catch(err => {
            console.error(err);
            onError();
            return false;
        });
};
